import { SvgIcon, SvgIconProps } from "@material-ui/core";

export function CertificateIcon(props: SvgIconProps): JSX.Element {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props} style={{ scale: "110%" }}>
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M 19.425 14.176 L 19.425 11.551 C 19.425 9.687 17.914 8.176 16.05 8.176 L 14.55 8.176 C 13.929 8.176 13.425 7.672 13.425 7.051 L 13.425 5.551 C 13.425 3.687 11.914 2.176 10.05 2.176 L 8.175 2.176 M 10.425 2.176 L 5.55 2.176 C 4.929 2.176 4.425 2.68 4.425 3.301 L 4.425 20.551 C 4.425 21.172 4.929 21.676 5.55 21.676 L 18.3 21.676 C 18.921 21.676 19.425 21.172 19.425 20.551 L 19.425 11.176 C 19.425 6.206 15.396 2.176 10.425 2.176 Z"
                stroke="currentColor"
                fill="transparent"
                className="stroke-[1.25]"
            />
            <path
                fillRule="evenodd"
                d="M 11.689 9.486 C 11.809 9.387 11.985 9.387 12.106 9.486 C 13.334 10.508 14.863 11.103 16.459 11.178 C 16.608 11.183 16.732 11.293 16.754 11.439 C 16.796 11.758 16.818 12.085 16.818 12.417 C 16.818 15.593 14.812 18.299 11.999 19.341 C 11.933 19.366 11.861 19.366 11.795 19.341 C 8.982 18.299 6.976 15.593 6.976 12.417 C 6.976 12.085 6.998 11.758 7.04 11.439 C 7.062 11.292 7.187 11.181 7.335 11.178 C 8.932 11.103 10.46 10.508 11.689 9.486 Z M 14.27 13.149 C 14.479 12.862 14.298 12.456 13.945 12.419 C 13.78 12.402 13.62 12.473 13.523 12.607 L 11.38 15.553 L 10.224 14.397 C 9.977 14.141 9.546 14.249 9.449 14.59 C 9.401 14.754 9.449 14.931 9.572 15.049 L 11.109 16.587 C 11.31 16.787 11.642 16.762 11.809 16.532 L 14.27 13.149 Z"
                clipRule="evenodd"
                fill="currentColor"
            />
        </SvgIcon>
    );
}
